<div class="uk-grid">
    <div class="uk-width-1-1 navbar">
        <p class="nav-text">{{'add_user' | translate}}</p>
    </div>


  <div class="uk-width-1-1 inner-shadow">

    <div class="uk-card uk-card-default uk-card-body uk-margin-medium-right uk-margin-medium-top">
            <div class="mobile-overflow">
                <form #userForm="ngForm" (ngSubmit)="onCreateUser(userForm)">
                    <div class="uk-grid">
                        <div class=" uk-width-1-2@m">
                            <label class="required">{{'email' | translate}}</label>
                            <input class="uk-input" type="text" name="email" #email="ngModel" ngModel required>
                        </div>
                        <div class=" uk-width-1-2@m">
                            <label class="required">{{'role' | translate}}</label>
                            <select class="uk-select" name="role" #role="ngModel" ngModel required>
                                <option value="0">{{'admin' | translate}}</option>
                                <option value="1">{{'sort_worker' | translate}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="uk-margin">
                        <button class="uk-button uk-button-primary" [disabled]="userForm.form.invalid">{{'add' | translate}}</button>
                    </div>

                </form>
            </div>

        </div>

    </div>

</div>

